import { useEffect, useState } from 'react';
import GerenciarEmpresaService, { getMidiaUrl } from '../../services/GerenciarEmpresaService';
import type { EmpresaDaFolha } from './FolhaDocumento';

/**
 * O cabeçalho da folha é o da empresa de verdade: nome, CNPJ, logo e a cor
 * da marca, as quatro de Gerenciar empresa e as mesmas que o PDF usa. Sem
 * cor da marca, a folha sai no cinza padrão do gerador. Falhou, sai sem.
 * `ativo` deixa quem só abre às vezes (a modal) buscar na hora de abrir.
 */
export const useEmpresaDaFolha = (ativo = true): EmpresaDaFolha => {
    const [empresa, setEmpresa] = useState<EmpresaDaFolha>({ nome: '' });

    useEffect(() => {
        if (!ativo) return;
        let vivo = true;
        GerenciarEmpresaService.getDadosGerais()
            .then(d => {
                if (!vivo) return;
                setEmpresa({
                    nome: d.nomeEmpresa || 'Sua empresa',
                    cnpj: d.cnpj || undefined,
                    logoUrl: d.pathLogo ? getMidiaUrl(d.pathLogo) : null,
                    cor: d.corMarca ?? null,
                });
            })
            .catch(() => { if (vivo) setEmpresa({ nome: 'Sua empresa' }); });
        return () => { vivo = false; };
    }, [ativo]);

    return empresa;
};
